// extracted by mini-css-extract-plugin
module.exports = {"rating-component":"styles_rating-component__nh7yG","shimmer":"styles_shimmer__XKhAB"};